// @ts-nocheck
import getCanOnlyOrderSample from "@store/Framework/Common/Utilities/samples/getCanOnlyOrderSample";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

const useCanOnlyOrderSample = convertSelectorToHook(getCanOnlyOrderSample);

export default useCanOnlyOrderSample;
